// extracted by mini-css-extract-plugin
export default {"table":"table-DqO5p","arrow":"arrow-LDcch","arrowInactive":"arrowInactive-cCsHC","columnHeader":"columnHeader-Y4hKU","arrowSorted":"arrowSorted-jGuVO","arrowUp":"arrowUp-FKOoP"};